import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

/**
 * Paginador del módulo Odoo (calco de shadcn Pagination): «1–20 de 57 · Anterior · 1 de 3 · Siguiente».
 * <od-paginador [page]="p" [limit]="20" [total]="n" unidad="movimientos" (cambiar)="ir($event)"></od-paginador>
 * Se oculta solo cuando no hay filas.
 */
@Component({
  selector: 'od-paginador',
  template: `
    <nav class="od-pag" *ngIf="total > 0" aria-label="Paginación">
      <span class="od-muted">{{ desde }}–{{ hasta }} de {{ total }} {{ unidad }}</span>
      <span class="od-pag-ctl" *ngIf="paginas > 1">
        <button type="button" class="od-btn od-btn-sm od-btn-ghost" [disabled]="page <= 1" (click)="cambiar.emit(page - 1)" aria-label="Página anterior">
          <od-icon name="chev" style="transform:rotate(90deg)"></od-icon>Anterior
        </button>
        <span class="od-pag-n">{{ page }} de {{ paginas }}</span>
        <button type="button" class="od-btn od-btn-sm od-btn-ghost" [disabled]="page >= paginas" (click)="cambiar.emit(page + 1)" aria-label="Página siguiente">
          Siguiente<od-icon name="chev" style="transform:rotate(-90deg)"></od-icon>
        </button>
      </span>
    </nav>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OdPaginadorComponent {
  @Input() page = 1;
  @Input() limit = 20;
  @Input() total = 0;
  @Input() unidad = 'filas';
  @Output() cambiar = new EventEmitter<number>();

  get paginas(): number { return Math.max(1, Math.ceil(this.total / this.limit)); }
  get desde(): number { return this.total ? (this.page - 1) * this.limit + 1 : 0; }
  get hasta(): number { return Math.min(this.total, this.page * this.limit); }
}
